import { Capabilities } from '@percent/admin-dashboard/api/capabilities'
import { adminService } from './admin/admin'
import { agentVerificationService } from './agentVerification/agentVerification'
import { authService } from './auth/auth'
import { activityCheckService } from './activityCheck/activityCheck'
import { milestonesService } from './milestones/milestonesService'
import { eligibilityService } from './eligibility/eligibility'
import { registriesService } from './registries/registries'
import { disbursementsService } from './disbursements/disbursements'
import { foundationsService } from './foundations/foundations'
import { reportingService } from './reporting/reportingService'
import { currenciesService } from './currencies/currencies'
import { bankDetailsService } from '@percent/admin-dashboard/api/actions/bankDetails/bankDetails'
import { donationRequestsService } from './donationRequests/donationRequests'
import { donationsService } from './donations/donations'
import { countriesService } from './countries/countriesService'
import { iamService } from '@percent/admin-dashboard/api/actions/iam/iamService'
import { donationMatchRequestsService } from './donationMatchRequests/donationMatchRequests'
import { autoRejectionListService } from './autoRejectionList/autoRejectionList'
import { validationSubmissionsService } from './validationSubmissions/validationSubmissions'
import { autoApprovalListService } from './autoApprovalList/autoApprovalList'
import { autoRequestRejectionListService } from './autoRequestRejectionList/autoRequestRejectionList'
import { grantProgramService } from './grantProgram/grantProgram'
import { accountService } from './accounts/accounts'
import { groupService } from './groups/groups'
import { internalServiceService } from './internalServices/internalServices'
import { authenticationService } from './authentication/authentication'
import { monetaryVerificationsService } from './monetaryVerifications/monetaryVerficiations'
import { sewaOnboardingService } from './sewaOnboarding/sewaOnboarding'
import { ralphOracleService } from './ralphOracle/ralphOracle'

export const services = (capabilities: Capabilities) => ({
  iamService: iamService(capabilities),
  adminService: adminService(capabilities),
  authService: authService(capabilities),
  accountService: accountService(capabilities),
  groupService: groupService(capabilities),
  internalServiceService: internalServiceService(capabilities),
  authenticationService: authenticationService(capabilities),
  agentVerificationService: agentVerificationService(capabilities),
  activityCheckService: activityCheckService(capabilities),
  milestonesService: milestonesService(capabilities),
  eligibilityService: eligibilityService(capabilities),
  registriesService: registriesService(capabilities),
  disbursementsService: disbursementsService(capabilities),
  foundationsService: foundationsService(capabilities),
  reportingService: reportingService(capabilities),
  currenciesService: currenciesService(capabilities),
  bankDetailsService: bankDetailsService(capabilities),
  donationRequestsService: donationRequestsService(capabilities),
  donationsService: donationsService(capabilities),
  countriesService: countriesService(capabilities),
  donationMatchingRequestService: donationMatchRequestsService(capabilities),
  autoRejectionListService: autoRejectionListService(capabilities),
  autoApprovalListService: autoApprovalListService(capabilities),
  autoRequestRejectionListService: autoRequestRejectionListService(capabilities),
  validationSubmissionsService: validationSubmissionsService(capabilities),
  grantProgramService: grantProgramService(capabilities),
  monetaryVerificationsService: monetaryVerificationsService(capabilities),
  sewaOnboardingService: sewaOnboardingService(capabilities),
  ralphOracleService: ralphOracleService(capabilities)
})

export type Services = ReturnType<typeof services>
